
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"20 9 36 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.27 31.516c0-.554-.176-1.01-.528-1.368-.351-.364-.937-.69-1.758-.976-.82-.293-1.458-.563-1.914-.81-1.517-.814-2.275-2.019-2.275-3.614 0-1.08.329-1.97.986-2.666.658-.697 1.55-1.11 2.676-1.24v-2.13h1.563v2.15c1.132.162 2.008.644 2.627 1.445.618.794.927 1.83.927 3.105h-2.363c0-.82-.186-1.465-.557-1.933-.364-.476-.862-.713-1.494-.713-.625 0-1.113.169-1.465.507-.351.339-.527.824-.527 1.456 0 .566.172 1.022.517 1.367.352.338.945.66 1.778.966.833.306 1.487.59 1.963.85.475.26.875.56 1.201.899.325.332.576.716.752 1.152.176.436.264.947.264 1.533 0 1.1-.339 1.992-1.016 2.676-.67.684-1.608 1.087-2.813 1.21v1.905h-1.552v-1.894c-1.29-.144-2.282-.606-2.979-1.387-.69-.781-1.035-1.816-1.035-3.106h2.373c0 .82.205 1.456.615 1.905.417.449 1.003.673 1.758.673.742 0 1.306-.178 1.69-.537.39-.358.586-.833.586-1.425z"}})])
          )
        }
      }
    